import React from 'react';
import '../../styles/act-mission-shakti/main.css';

const Main = () => {
    return (
        <div id='actMissionShaktiMain'>
            <div className="act-mission-shakti-main">
                <div className="container main-box mb-5">
                    <div className="box">
                        <div className="col-lg-5 col-sm-12">
                            <div className="image">
                                <span>Mission Shakti Abhiyan 2021</span>
                                <img src="../assets/images/activities/activity-5.jpg" alt="" />
                            </div>
                        </div>
                        <div className="col-lg-7 col-sm-12">
                            <div className="links">
                                <div className="link">
                                    <span>
                                        <img src="../assets/images/link.svg" alt="" />
                                    </span>
                                    <div className="content">
                                        <a
                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/01-free-medical-camp.pdf"
                                            target="blank"
                                        >
                                            <p>
                                                Free Medical Health Camp and medicine distribution for Girl
                                                Students on 1 March 2020.
                                            </p>
                                        </a>
                                        {/* <p>Campus Admission Portal 2023</p> */}
                                    </div>
                                </div>
                                <div className="link">
                                    <span>
                                        <img src="../assets/images/link.svg" alt="" />
                                    </span>
                                    <div className="content">
                                        <a
                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/mental-health.pdf"
                                            target="blank"
                                        >
                                            <p>
                                                Online guest lectures on"Mental health issues in Females"
                                                02.03.2021
                                            </p>
                                        </a>
                                    </div>
                                </div>
                                <div className="link">
                                    <span>
                                        <img src="../assets/images/link.svg" alt="" />
                                    </span>
                                    <div className="content">
                                        <a
                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/yoga-camp.pdf"
                                            target="blank"
                                        >
                                            <p>"Yoga Camp" on 01.03.2021- 07.03.2021</p>
                                        </a>
                                    </div>
                                </div>
                                <div className="link">
                                    <span>
                                        <img src="../assets/images/link.svg" alt="" />
                                    </span>
                                    <div className="content">
                                        <a
                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/poster-slogan-quiz.pdf"
                                            target="blank"
                                        >
                                            <p>
                                                Poster/slogan/quiz in Dept. of History from 3rd - 4th March
                                                2021
                                            </p>
                                        </a>
                                    </div>
                                </div>
                                <div className="link">
                                    <span>
                                        <img src="../assets/images/link.svg" alt="" />
                                    </span>
                                    <div className="content">
                                        <a
                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/courageous-success.pdf"
                                            target="blank"
                                        >
                                            <p>
                                                Online Guest lecture on 'Courageous success with curiosity and
                                                persistence" and "Vashvik Parichaya mein Bhartiya Nari" on 3rd
                                                March 2021.
                                            </p>
                                        </a>
                                    </div>
                                </div>
                                <div className="link">
                                    <span>
                                        <img src="../assets/images/link.svg" alt="" />
                                    </span>
                                    <div className="content">
                                        <a
                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/legal-right.pdf"
                                            target="blank"
                                        >
                                            <p>
                                                Online guest lecture on" Legal Rights of Women" 3rd March 2021
                                            </p>
                                        </a>
                                    </div>
                                </div>
                                <div className="link">
                                    <span>
                                        <img src="../assets/images/link.svg" alt="" />
                                    </span>
                                    <div className="content">
                                        <a
                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/psychology-psychlogical.pdf"
                                            target="blank"
                                        >
                                            <p>
                                                Legal psychology/ Psychological counselling for girls 4th
                                                March 2021
                                            </p>
                                        </a>
                                    </div>
                                </div>
                                <div className="link">
                                    <span>
                                        <img src="../assets/images/link.svg" alt="" />
                                    </span>
                                    <div className="content">
                                        <a
                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/one-dacamp.pdf"
                                            target="blank"
                                        >
                                            <p>One day camp on Self Defence 5th March 2021 in Yoga Dept</p>
                                        </a>
                                    </div>
                                </div>
                                <div className="link">
                                    <span>
                                        <img src="../assets/images/link.svg" alt="" />
                                    </span>
                                    <div className="content">
                                        <a
                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/karate-camp.pdf"
                                            target="blank"
                                        >
                                            <p>Karate Camp 4-6th March 2021 in History Dept</p>
                                        </a>
                                    </div>
                                </div>
                                <div className="link">
                                    <span>
                                        <img src="../assets/images/link.svg" alt="" />
                                    </span>
                                    <div className="content">
                                        <a
                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/hindi-sahitya.pdf"
                                            target="blank"
                                        >
                                            <p>
                                                Webinar on 'Hindi Sahitya avam Sahitya' by Dept. of Hindi on
                                                7th March 2021
                                            </p>
                                        </a>
                                    </div>
                                </div>
                                <div className="link">
                                    <span>
                                        <img src="../assets/images/link.svg" alt="" />
                                    </span>
                                    <div className="content">
                                        <a
                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/oath-taking.pdf"
                                            target="blank"
                                        >
                                            <p>Mission Shakti oath taking 8th March 2021</p>
                                        </a>
                                    </div>
                                </div>
                                <div className="link">
                                    <span>
                                        <img src="../assets/images/link.svg" alt="" />
                                    </span>
                                    <div className="content">
                                        <a
                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/awareness-march.pdf"
                                            target="blank"
                                        >
                                            <p>AWARENESS MARCH – 8th March</p>
                                        </a>
                                    </div>
                                </div>
                                <div className="link">
                                    <span>
                                        <img src="../assets/images/link.svg" alt="" />
                                    </span>
                                    <div className="content">
                                        <a
                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/online-poster-woman.pdf"
                                            target="blank"
                                        >
                                            <p>
                                                Online Poster/ slogan on "Women Empowerment" on 10th March
                                                2021.
                                            </p>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Main;